import type { IMemberPaperResponse } from "@api/members/papers";
import type { IConferencePaperTable } from "@/template/articlesAndBooks/conferencePaper/table";

export function conferencePaperTableMapper(
  data: IMemberPaperResponse,
): IConferencePaperTable {
  return {
    id: data?.id,
    partners: data?.authors?.split(",")?.map((author) => author?.trim()),
    journalName: data?.publisher,
    paperName: data?.title,
    publishYear: data?.publication_date,
    isApproved: data?.is_approved,
  };
}
